exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wp-block-yikes-inc-easy-forms-easy-forms-block textarea.yikes-mailchimp-submit-button-span-text {\n  background: none;\n  text-align: center; }\n\n.wp-block-yikes-inc-easy-forms-easy-forms-block select {\n  height: auto; }\n", ""]);

// exports
